module.exports = __webpack_public_path__ + "media/images/vedett_allatok/vedett4-faa6fb83287532fbc0ecc3fd78e50254.jpg";